<template>
  <div class="animated fadeIn">
    <b-card >
      <div slot="header">Report - Customer Delivery Status
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="5">
            <b-input-group >
                <b-input-group-prepend><label>Customer Group</label></b-input-group-prepend>
                <b-form-select v-model="tblData.customer_group" :plain="true" :options="custgroup" @change="reloaddata" :disabled="tblData.viewOption!='customer'"></b-form-select> 
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label style="width:130px !important;">Customer</label></b-input-group-prepend>
                <b-form-input v-model="tblData.customer" placeholder="Customer" :disabled="tblData.viewOption!='customer'" readonly></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="lkuCustomerShow=true" :disabled="tblData.viewOption!='customer'" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
                <b-form-checkbox
                  class="ml-1 mt-2 text-left"
                  v-model="tblData.dggroup"
                  value="1" unchecked-value="0" :disabled="tblData.viewOption!='customer'">Include Group</b-form-checkbox>
            </b-input-group >
            <b-input-group>
              <b-input-group-prepend><label style="width:130px !important;">Order Date</label></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
              <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
            </b-input-group>
        </b-col>
        <b-col  lg="5">
          <b-input-group>
            <b-input-group-prepend><label style="width:100px !important;">Item Category</label></b-input-group-prepend>
            <b-form-select v-model="tblData.itemcategory" :plain="true" :options="itemCategories"></b-form-select>
          </b-input-group>
          <b-input-group >
              <b-input-group-prepend><label style="width:100px !important;">Item </label></b-input-group-prepend>
              <b-form-input v-model="tblData.item" placeholder="Item Name" @change="itemChange"></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="lkuItemShow=true" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
                <b-input-group-append><b-button class="btn btn-secondary ml-2" style="width:110px !important;" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button></b-input-group-append>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label style="width:100px !important;">Status</label></b-input-group-prepend>
              <b-form-select v-model="tblData.status" :plain="true" :options="statusoptions"></b-form-select>
              <b-input-group-prepend><label class='label-input-group ml-1'>View Option By</label></b-input-group-prepend>
              <b-form-radio-group v-model="tblData.viewOption" class="mt-1">
                  <b-form-radio value="customer">Customer</b-form-radio>
                  <b-form-radio value="items">Items</b-form-radio>
              </b-form-radio-group>
              <b-input-group-append><b-button class="btn btn-success ml-2" style="width:110px !important;" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button></b-input-group-append>
            </b-input-group >
        </b-col>
      </b-row>
        <b-table
        class="mb-0"
            ref="tblVendor"
            responsive
            striped hover 
            sticky-header="500px"
            style="font-size:smaller;"
            :items="data"
            :fields="tblFields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            :key="tblData.limit" 
            @row-clicked="selectItem"
          >
        <template v-slot:cell(tanggal)="data">
          <span v-if="(data.item.tanggal)">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
          </span>
        </template>
        <template v-slot:cell(orderdate)="data">
          <span v-if="(data.item.orderdate)">
          {{ data.item.orderdate | moment("DD MMM YYYY") }}
          </span>
        </template>
        <template v-slot:cell(qtyOrder)="data">
          {{data.item.qtyOrder | numFormat}}
        </template>
        <template v-slot:cell(qtyDeliver)="data">
          {{data.item.qtyDeliver | numFormat}}
        </template>
        <template v-slot:cell(qtyChecker)="data">
          {{data.item.qtyChecker | numFormat}}
        </template>
        <template v-slot:cell(qtyReceipt)="data">
          {{data.item.qtyReceipt | numFormat}}
        </template>
        <template v-slot:cell(qtyRetur)="data">
          {{data.item.qtyRetur | numFormat}}
        </template>
        <template v-slot:cell(qtyTransferIn)="data">
          {{data.item.qtyTransferIn | numFormat}}
        </template>
        <template v-slot:cell(qtyTransferOut)="data">
          {{data.item.qtyTransferOut | numFormat}}
        </template>
          <template v-slot:cell(action)="data">
            <div class="text-center">
            <a href="javascript:void(0)" @click="edit(data.item)">
              <i class="fa fa-pencil"></i>
            </a>
            |
            <a href="javascript:void(0)" class="text-danger" @click="deleteConfirm(data.item)">
              <i class="fa fa-trash"></i>
            </a>
            </div>
          </template>

          <template v-slot:custom-foot>
            <tr v-show="footerShow">
              <td colspan="3"><b>Total</b></td>
              <td class="text-right"><b>{{tblData.ttlOrder}}</b></td>
              <td class="text-right"><b>{{tblData.ttlChecker}}</b></td>
              <td class="text-right"><b>{{tblData.ttlDeliver}}</b></td>
              <td class="text-right"><b>{{tblData.ttlReceipt}}</b></td>
              <td class="text-right"><b>{{tblData.ttlRetur}}</b></td>
            </tr>
          </template>

      </b-table>
      <b-row>
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total | numFormat}} entries
          </div>
        </b-col>
        <b-col cols="2" >
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
            </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination v-if="pagination"
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>     
    <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Master Item " :centered="true">
        <lku-item @click="onSelectLkuItem"  jasa="0" isactive="1" :formdata="itemList" ></lku-item>
    </b-modal> 
    <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
        <lku-customer @click="onSelectLkuCustomer" :customer_group="tblData.customer_group"></lku-customer>
    </b-modal>        

  </div>
</template>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import toastr from "mini-toastr";
import order from "../../apis/bakeryorder";
import lkuCustomer from "../lookup/lkuCustomerGroup";
import lkuItem from "../lookup/lkuItemLazzy";
import report from "../../apis/bakeryreport";
import customer from "../../apis/bakerycustomer";
import item from "../../apis/bakeryitem";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  components: {Loading, lkuCustomer, lkuItem},
  mixins: [validationMixin], 
  data() {
    return {
      showDelConfirm: false,
      showFrmCustomer:false,
      lkuCustomerShow:false,
      isLoading:false,
      footerShow: false,
      custgroup:[
            { value: '', text: '-- ALL--' }
        ],
      tblFields: [
          {
            key: "orderdate",
            label: "Order Date",
            thStyle: "width:90px",
            sortable: true
          },
          {
            key: "orderno",
            label: "Order No.",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "CustName",
            label: "Customer",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "CustCode",
            label: "Customer Code",
            thStyle: "width:100px",
            sortable: true
          },

          {
            key: "partnumber",
            label: "Item No.",
            thStyle: "width:120px",
            sortable: true
          },
          {
            key: "itemname",
            label: "Item Name",
            thStyle: "width:200px",
            stickyColumn: true,
            sortable: true
          },
          {
            key: "itemcategory",
            label: "Item Category",
            thStyle: "width:120px",
            sortable: true
          },
          {
            key: "qtyOrder",
            tdClass: "text-right",
            label: "Qty.Order",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "qtyChecker",
            tdClass: "text-right",
            label: "Qty.Checker",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "checker",
            tdClass: "text-right",
            label: "Checker",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "qtyDeliver",
            tdClass: "text-right",
            label: "Qty.Deliver",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "driver",
            tdClass: "text-right",
            label: "Driver",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "qtyReceipt",
            tdClass: "text-right",
            label: "Qty.ETALASE AWAL",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "sales",
            tdClass: "text-right",
            label: "Sales/MD ETALASE",
            thStyle: "width:120px",
            sortable: true
          },
          {
            key: "qtyTransferIn",
            tdClass: "text-right",
            label: "Transfer IN",
            thStyle: "width:90px",
            sortable: true
          },
          {
            key: "qtyTransferOut",
            tdClass: "text-right",
            label: "Transfer OUT",
            thStyle: "width:90px",
            sortable: true
          },
          {
            key: "qtyReceiptEtalase",
            tdClass: "text-right",
            label: "Qty.ETALASE AKHIR",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "status",
            tdClass: "text-right",
            label: "STATUS DELIVERY",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "qtyRetur",
            tdClass: "text-right",
            label: "Qty.RETUR",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "salesretur",
            tdClass: "text-right",
            label: "Sales/MD Retur",
            thStyle: "width:120px",
            sortable: true
          },
      ],
      model:{},
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        ttlOrder: 0,
        ttlChecker: 0,
        ttlDeliver: 0,
        ttlReceipt: 0,
        ttlTransferIn: 0,
        ttlTransferOut: 0,
        sortBy: null,
        sortDesc: false,
        headcategory:null,
        viewOption:'customer',
        customer_group:'',
        customer_id:'',
        customer: '', 
        tgl1:moment().format("YYYY-MM-DD"),
        tgl2:moment().format("YYYY-MM-DD"),
        status:'',
        itemcategory:''
      },
      limit:15,
      pagination: false,
      items:[],
      frmdata: {qtyRetur:0, itemno:'', tanggal:''},
      lkuItemShow:false,
      itemList:{},
        uanguser: this.$store.state.user.matauang,
      showFilter:true,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
      headCategories:[],
      statusoptions:[
        { text: '-- All --', value: '' },
        { text: 'SELISIH', value: 'SELISIH'},
        { text: 'SAMA', value:'SAMA' }
      ],
      itemCategories: [
        { text: '-- All --', value: '' }
      ],
    };
  },
  computed: {
    invalidmodel() {
      this.$v.tblData.$touch();
      return this.$v.tblData.$invalid;
    },
  },
  watch:{
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    }, 
    
    'tblData.viewOption' : function(newval) {
      this.clearFilter();
      if (newval=='customer') {
        this.footerShow = false;
        this.tblFields= [
        {
            key: "orderdate",
            label: "Order Date",
            thStyle: "width:90px",
            sortable: true
          },
          {
            key: "orderno",
            label: "Order No.",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "CustName",
            label: "Customer",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "CustCode",
            label: "Customer Code",
            thStyle: "width:100px",
            sortable: true
          },

          {
            key: "partnumber",
            label: "Item No.",
            thStyle: "width:120px",
            sortable: true
          },
          {
            key: "itemname",
            label: "Item Name",
            thStyle: "width:200px",
            stickyColumn: true,
            sortable: true
          },
          {
            key: "itemcategory",
            label: "Item Category",
            thStyle: "width:120px",
            sortable: true
          },
          {
            key: "qtyOrder",
            tdClass: "text-right",
            label: "Qty.Order",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "qtyChecker",
            tdClass: "text-right",
            label: "Qty.Checker",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "checker",
            tdClass: "text-right",
            label: "Checker",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "qtyDeliver",
            tdClass: "text-right",
            label: "Qty.Deliver",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "driver",
            tdClass: "text-right",
            label: "Driver",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "qtyReceipt",
            tdClass: "text-right",
            label: "Qty.ETALASE AWAL",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "sales",
            tdClass: "text-right",
            label: "Sales/MD ETALASE",
            thStyle: "width:120px",
            sortable: true
          },
          {
            key: "qtyTransferIn",
            tdClass: "text-right",
            label: "Transfer IN",
            thStyle: "width:90px",
            sortable: true
          },
          {
            key: "qtyTransferOut",
            tdClass: "text-right",
            label: "Transfer OUT",
            thStyle: "width:90px",
            sortable: true
          },
          {
            key: "qtyReceiptEtalase",
            tdClass: "text-right",
            label: "Qty.ETALASE AKHIR",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "status",
            tdClass: "text-right",
            label: "STATUS DELIVERY",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "qtyRetur",
            tdClass: "text-right",
            label: "Qty.RETUR",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "salesretur",
            tdClass: "text-right",
            label: "Sales/MD Retur",
            thStyle: "width:120px",
            sortable: true
          },
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          this.tblFields.push({
            key: `${dims[i].value}Txt`,
            label: dims[i].text,
            sortable: true
          });
        }
      } else {
        this.footerShow = true;
        this.tblFields= [
        {
            key: "tanggal",
            label: "Order Date",
            thStyle: "width:150px",
            sortable: true
          },
          {
            key: "partnumber",
            label: "Item",
            thStyle: "width:80px",
            sortable: true
          },
          {
            key: "itemname",
            label: "Item Name",
            stickyColumn: true,
            sortable: true
          },
          {
            key: "itemcategory",
            label: "Item Category",
            thStyle: "width:120px",
            sortable: true
          },
          {
            key: "qtyOrder",
            tdClass: "text-right",
            label: "Qty Order",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "qtyChecker",
            tdClass: "text-right",
            label: "Qty Checker",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "qtyDeliver",
            tdClass: "text-right",
            label: "Qty Deliver",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "qtyReceipt",
            tdClass: "text-right",
            label: "Qty Etalase AWAL",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "qtyRetur",
            tdClass: "text-right",
            label: "Qty Retur",
            thStyle: "width:100px",
            sortable: true
          },
        ];
      }
      
      let newFields = [];
      this.tblFields.map((data,index)=>{
        if(!data.hide){
          newFields.push(data);
        }
      })
      this.tblFields = newFields;
      this.refresh();
    },

  },

  created: async function(){
    try {
      const [custgroup,itemCategories] = await Promise.all([
                customer.group(),item.group()
                ]) ;
            if(custgroup){
                 custgroup.map((data)=>{
                    this.custgroup.push({
                        value:data.value,
                        text:data.text
                    });
                });
            }
            if(itemCategories){
                 itemCategories.map((data)=>{
                    this.itemCategories.push({
                        value:data.nama,
                        text:data.nama
                    });
                });
            }
    } catch (error) {
        this.isLoading = false;
          console.log('error : ', error);
          toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
    }

  },

  methods: {
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.orderlist) {
            this.tblData[key] = filter.orderlist[key];
            filtered=true;
        }
        let list =[];
        if (filtered === true) {
          if (!(filter.orderlist.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.orderlist;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=false; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {                  
                  if (this.tblData.viewOption=='customer') {
                      // console.log("#this.tblData: ", this.tblData);
                      list = await report.customerdelivery(this.tblData);
                  } else {
                      list = await order.itemlist(this.tblData);
                  }
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
            }
        } else {
            this.isLoading=true;
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            try {
              if (this.tblData.viewOption=='customer') {
                  // console.log("#this.tblData else: ", this.tblData);
                  list = await report.customerdelivery(this.tblData);
              } else {
                  list = await order.itemlist(this.tblData);
              }
              this.pagination=true;
              this.isLoading=false;  
              return list;        
            } catch (error) {
              this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
            }
        }
    },    
    selectItem(record,index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    async reloaddata(val) {
      // this.isLoading = true;
      this.tblData.customer_group = val;
      this.tblData.customer_id = '';
      this.tblData.customer = '';
      // this.isLoading = false;
    },
    refresh() {
      this.$refs.tblVendor.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.itemno = '';
        this.tblData.item =  '';
        this.tblData.tgl1 = '';
        this.tblData.tgl2 = '';
        this.tblData.customer_id = '';
        this.tblData.customer = '';
        this.tblData.CustName =  '';
        this.tblData.customer_group = '';
        this.tblData.itemcategory = '';
        // this.refresh();
    },    
    itemChange: function () {
        this.tblData.itemno = '';
    },
    saveFilter() {
      const keys = ['tgl1', 'tgl2','itemno', 'item', 'itemcategory'];
      let filtered = false;
      const orderlist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              orderlist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          orderlist.page=this.tblData.page;
          orderlist.limit=this.tblData.limit;
          orderlist.sortBy=this.tblData.sortBy;
          orderlist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.orderlist=orderlist;
          this.$store.commit("filter", filter);
      }
    },    
    onSelectLkuItem: function (lkuData) {
        this.itemList=lkuData;
        this.lkuItemShow=false;
        this.tblData.itemno = lkuData.selected.itemno;
        this.tblData.item = lkuData.selected.itemname;
        this.frmdata.itemno = lkuData.selected.itemno;
        this.frmdata.item = lkuData.selected.itemname;
        this.frmdata.partnumber = lkuData.selected.partnumber;
        this.frmdata.iteminfo = lkuData.selected.itemname + '  |  '+lkuData.selected.partnumber;
        this.frmdata.unitsize = lkuData.selected.unitsize;
        this.frmdata.unitprice = lkuData.selected.unitprice;
    },

    onSelectLkuCustomer: async function (_selected) {
      this.tblData.customer_id = _selected.customer_id;
        this.tblData.CustCode = _selected.CustCode;
        this.tblData.CustName = _selected.CustName;
        this.tblData.customer = `${_selected.CustName} | ${_selected.CustCode}`;
        this.lkuCustomerShow=false;
    },    
    exportxls: async function() {
        try {
              this.isLoading=true;
              this.tblData.tgl1 = moment(this.tblData.tgl1).format('YYYY-MM-DD');
              this.tblData.tgl2 = moment(this.tblData.tgl2).format('YYYY-MM-DD');

              //const response = await report.customerdeliveryxls(this.tblData);
              let response ='';
              if (this.tblData.viewOption=='customer') {
                  response = await report.customerdeliveryxls(this.tblData);
              } else {
                  response = await report.customerdeliveryitemxls(this.tblData);
              }
              
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'customer_delivery_status.xlsx');
              document.body.appendChild(link);
              link.click();
              this.isLoading=false;    
        } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
        }
    },   
    close(){
      router.push("home");
    },    
  }
};
</script>
